import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  NumberField,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  usePermissions,
  FunctionField,
} from 'react-admin'

import DeleteButton from '../../components/DeleteButton'
import FilterComponent from '../../components/Filter'

const Actions = props => {
  const { resource, currentSort, filterValues, exporter, basePath } = props
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={false}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={10000}
      />
    </TopToolbar>
  )
}

const AiBooksFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search by title" source="title" alwaysOn />
  </FilterComponent>
)

const AiBooksList = () => {
  const { permissions } = usePermissions()

  return (
    <List
      filters={<AiBooksFilter />}
      actions={<Actions />}
      bulkActionButtons={false}
      sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="id" />
        <TextField source="title" />
        <FunctionField
          label="Status"
          render={record => {
            const statusColors = {
              new: '#f44336',
              text_extracted: '#ff9800',
              tts_generated: '#2196f3',
              completed: '#4caf50',
            }
            const statusLabels = {
              new: 'New',
              text_extracted: 'Text Extracted',
              tts_generated: 'TTS Generated',
              completed: 'Completed',
            }
            return (
              <span
                style={{
                  color: statusColors[record.status] || '#666',
                  fontWeight: 'bold',
                  textTransform: 'capitalize',
                }}>
                {statusLabels[record.status] || record.status}
              </span>
            )
          }}
        />
        <TextField source="sourcePdfPath" label="Source PDF Path" />
        <NumberField source="chapterCount" label="Chapter Count" />
        <NumberField source="completedChapters" label="Completed Chapters" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <EditButton />
        <DeleteButton permissions={permissions} undoable={false} />
      </Datagrid>
    </List>
  )
}

export default AiBooksList
